import { getColor } from 'common/constants/_colors';

export const GRAPH_COLORS = [
  {
    hex: getColor('melrose'),
    label: 'melrose'
  },
  {
    hex: getColor('dodgerBlue'),
    label: 'dodgerBlue'
  },
  {
    hex: getColor('indigo'),
    label: 'indigo'
  },
  {
    hex: getColor('waikawaGray'),
    label: 'waikawaGray'
  },
  {
    hex: getColor('funGreen'),
    label: 'funGreen'
  },
  {
    hex: getColor('pastelGreen'),
    label: 'pastelGreen'
  },
  {
    hex: getColor('orangePeel'),
    label: 'orangePeel'
  },
  {
    hex: getColor('torchRed'),
    label: 'red'
  }
];
